import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const CalloutBox = dynamic(() => import('./CalloutBox'));

const defaultBodyText =
	'Your information is legally protected and will only be used to evaluate your potential claim.\n' +
	'We do not sell data to third-party marketers. All inquiries are handled with strict attorney-\n' +
	'client confidentiality standards.';

export const defaultOptions = {
	logo: {
		'@type': '@builder.io/core:Reference',
		id: '0d7c4557c5774bddb1e2df11f9b85927',
		model: 'logo',
	},
	title: 'Privacy Guarantee',
	bodyText: defaultBodyText,
	showTitle: true,
	showBodyText: true,
	showAccent: true,
	backgroundColor: 'var(--color-light-grey)',
	accentColor: 'var(--color-dark-burgundy)',
} as const;

Builder.registerComponent(CalloutBox, {
	name: 'CalloutBox',
	inputs: [
		{
			name: 'logo',
			friendlyName: 'Logo/Icon',
			type: 'reference',
			model: 'logo',
			required: false,
			defaultValue: defaultOptions.logo,
		},
		{
			name: 'title',
			friendlyName: 'Title',
			type: 'string',
			required: true,
			defaultValue: defaultOptions.title,
		},
		{
			name: 'bodyText',
			friendlyName: 'Body Text',
			type: 'string',
			required: true,
			defaultValue: defaultOptions.bodyText,
		},
		{
			name: 'showTitle',
			friendlyName: 'Show Title',
			type: 'boolean',
			defaultValue: defaultOptions.showTitle,
			helperText: 'Toggle visibility of the title',
		},
		{
			name: 'showBodyText',
			friendlyName: 'Show Body Text',
			type: 'boolean',
			defaultValue: defaultOptions.showBodyText,
			helperText: 'Toggle visibility of the body text',
		},
		{
			name: 'showAccent',
			friendlyName: 'Show Accent Border',
			type: 'boolean',
			defaultValue: defaultOptions.showAccent,
			helperText: 'Toggle visibility of the left border accent',
		},
		{
			name: 'titleColor',
			friendlyName: 'Title Color',
			type: 'color',
			helperText: 'Color for the title text',
		},
		{
			name: 'bodyTextColor',
			friendlyName: 'Body Text Color',
			type: 'color',
			helperText: 'Color for the body text',
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: defaultOptions.backgroundColor,
			helperText: 'Background color of the callout box',
		},
		{
			name: 'accentColor',
			friendlyName: 'Accent Color',
			type: 'color',
			defaultValue: defaultOptions.accentColor,
			helperText: 'Color for the left border accent',
		},
	],
	image: getIconUrl(Icon.DEFAULT),
});
